<template>
    <div class="clockBlock">
        <div class="clock" :style="clockStyle">
            <img class="face" src="/img/guidance/clock_korall.svg"/>
            <div class="hour hand" :style="hourStyle"></div>
            <div class="minute hand" :style="minuteStyle"></div>
        </div>
        <div class="date" :style="dateStyle">{{ date }}</div>
    </div>
</template>

<script>

const monthNames = ['Jänner', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

export default {
    name: 'Clock',
    props: ['time', 'size'],
    computed: {
        clockStyle() {
            return `width:${this.size}px; height:${this.size}px`;
        },
        hourStyle() {
            const angle = this.time.getHours() * 30 + this.time.getMinutes() / 2;
            return `transform: rotateZ(${angle}deg)`;
        },
        minuteStyle() {
            const angle = this.time.getMinutes() * 6;
            return `transform: rotateZ(${angle}deg)`;
        },
        dateStyle() {
            return `font-size: ${this.size / 13}px`;
        },
        date() {
            return `${this.time.getDate()}. ${monthNames[this.time.getMonth()]} ${this.time.getFullYear()}`;
        },
    },
}
</script>

<style scoped>
.clock {
    position: relative;
}

.face {
    width: 100%;
    height: 100%;
}

.hand {
    background: #ff4747;
    position: absolute;
    border-radius: 1000px;
}

.hour {
    height: 33%;
    left: 48.75%;
    top: 25%;
    transform-origin: 50% 75.76%;
    width: 2.5%;
}

.minute {
    height: 50%;
    left: 49%;
    top: 10%;
    transform-origin: 50% 80%;
    width: 2%;
}

.date {
    text-align: center;
    margin-top: 6%;
    color: #ff4747;
    font-family: Inter;
}
</style>
